import { render, staticRenderFns } from "./ReservaView.vue?vue&type=template&id=42374e79&"
import script from "./ReservaView.vue?vue&type=script&lang=js&"
export * from "./ReservaView.vue?vue&type=script&lang=js&"
import style0 from "./ReservaView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports